<template>
  <div class="flex items-center gap-2 w-38">
    <button
      type="button"
      class="h-8 w-8 flex items-center justify-center rounded-sm border border-black/10 disabled:opacity-40"
      :disabled="quantity <= min"
      @click="decrement"
    >
      <FontAwesomeIcon :icon="['far', 'minus']" class="text-base" />
    </button>

    <span
      class="flex-1 text-center select-none text-base"
      :class="max === 0 && 'opacity-40'"
    >
      {{ quantity ?? 0 }}
    </span>

    <button
      type="button"
      class="h-8 w-8 flex items-center justify-center rounded-sm border border-black/10 disabled:opacity-40"
      :disabled="quantity >= max"
      @click="increment"
    >
      <FontAwesomeIcon :icon="['far', 'plus']" class="text-base" />
    </button>
  </div>
</template>

<script setup>
import { ref } from 'vue'
const props = defineProps({
  modelValue: {
    type: Number,
    default: 0,
  },
  value: {
    type: Number,
    default: 0,
  },
  min: {
    type: Number,
    default: 0,
  },
  max: {
    type: Number,
    default: Infinity,
  },
})

const emit = defineEmits([
  'update:modelValue',
  'change',
  'decrement',
  'increment',
])

const quantity = ref(props.modelValue || props.value)

const decrement = () => {
  if (quantity.value > props.min) {
    quantity.value -= 1
    emit('update:modelValue', quantity.value)
    emit('change', quantity.value)
    emit('decrement', quantity.value)
  }
}

const increment = () => {
  if (quantity.value < props.max) {
    quantity.value += 1
    emit('update:modelValue', quantity.value)
    emit('change', quantity.value)
    emit('increment', quantity.value)
  }
}
</script>
